import React, { useState, useEffect } from "react";
import { API_KEY } from "../utils/constants";
import { signUpAPI } from "../api/api";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../components/loader";
import { createOTPAPI} from '../api/api';

function OTPVerify() {
  const navigate = useNavigate();
  const location = useLocation();

  const { user_name, email, phone, password,city,state, createdOtp } = location.state || {};

  const [otp, setOTP] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);

  useEffect(() => {
    if (isResendDisabled) {
      const countdown = setInterval(() => {
        setTimer((prev) => {
          if (prev === 1) {
            clearInterval(countdown);
            setIsResendDisabled(false);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [isResendDisabled]);

  const handleLogin = async () => {
 
    if (otp === createdOtp) {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("__api_key__", API_KEY);
      formData.append("user_name", user_name);
      formData.append("email", email);
      formData.append("phone", phone);
      formData.append("city", city);
      formData.append("state", state);
      formData.append("password", password);
      await signUpAPI(formData)
        .then((res) => {
          setIsLoading(false);
          if (res.data.state === "OK") {
            localStorage.setItem("user", JSON.stringify(res.data.data.user_entity));
            
            if (window.Android && typeof window.Android.sendFCM === "function"){
              window.Android.sendFCM(res.data.data.user_entity.uid);
            }
            
            navigate("/home");
          } else if (res.data.data.exceptions.user_with_same_phone_already_exists) {
            toast.error("Phone number registered");
          }
        })
        .catch((error) => console.log(error));
    } else {
      toast.error("Wrong OTP");
    }
  };

  const handleOtpChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 6) {
      setOTP(value);
    }
  };
  
  useEffect(() => {
    if (otp.length === 6) {
      handleLogin();
    }
  }, [otp]); // Run when otp changes
  
  const handleResendOtp = async() => {
    // Add API call to resend OTP if needed

  const formData = new FormData();
    formData.append('__api_key__', API_KEY);
    formData.append('mobile_number', phone);
    formData.append('otp', createdOtp);
    formData.append('request_id', '1234');

    setIsLoading(true);
    await createOTPAPI(formData)
    .then((res) => {
      setIsLoading(false);
      if (res.data.state === 'OK') {
        setIsResendDisabled(true);
        setTimer(60);
        toast.success('OTP sent to your mobile number')
      }
    })
    .catch((error) => console.log(error));
  };


  
  return (
    <div className="main login">
      <div className="container text-center" style={{ margin: "20px" }}>
        <h5 className="heading">Verify OTP</h5>
        <div className="text-center mt-4">
          <label className="mb-2">Enter OTP sent to your mobile number</label>
          <input
            type="text"
            value={otp}
            onChange={handleOtpChange}
            maxLength={6}
            style={{
              marginTop: "30px",
              padding: "12px 16px",
              textAlign: "center",
              border: "1px solid #fff",
              borderRadius: "8px",
              fontSize: "20px",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
              outline: "none",
              width: "100%",
              transition: "border-color 0.2s, box-shadow 0.2s",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#ccc")}
            onBlur={(e) => (e.target.style.borderColor = "#fff")}
            placeholder="Enter OTP"
          />
        </div>

        <button
          type="button"
          className="form-control login mt-4 rounded-5 shadow"
          onClick={handleLogin}
        >
          CONFIRM
        </button>

        <div className="text-center mt-3" style={{ padding: "10px", marginTop:'20px'}}>
          {isResendDisabled ? (
            <span style={{ color: "gray", fontSize: "14px" }}>Resend OTP in {timer}s</span>
          ) : (
            <span
              style={{ color: "blue", cursor: "pointer", fontSize: "14px" }}
              onClick={handleResendOtp}
            >
              Resend OTP
            </span>
          )}
        </div>
      </div>
      <Loader isLoading={isLoading} />
    </div>
  );
}

export default OTPVerify;